import api from './apiClient';

export interface PendingFollower {
  id: number;
  line_user_id: string;
  display_name: string | null;
  followed_at: string | null;
}

export interface LinkedUser {
  user_id: number;
  username: string | null;
  full_name: string | null;
  role: string | null;
  line_user_id: string;
  is_enabled: boolean;
}

/** 未連携のLINE友だち一覧を取得 */
export const getPendingFollowers = async (): Promise<PendingFollower[]> => {
  const res = await api.get('/line/pending-followers');
  return res.data?.data || [];
};

/** 連携済みユーザー一覧を取得 */
export const getLinkedUsers = async (): Promise<LinkedUser[]> => {
  const res = await api.get('/line/linked-users');
  return res.data?.data || [];
};

/** 管理者が指定ユーザーに line_user_id を紐付ける */
export const linkUser = async (userId: number, lineUserId: string): Promise<void> => {
  await api.post('/line/link-user', { user_id: userId, line_user_id: lineUserId });
};

/** 管理者が指定ユーザーのLINE連携を解除する */
export const unlinkUser = async (userId: number): Promise<void> => {
  await api.post('/line/unlink-user', { user_id: userId });
};

/** テストメッセージを送信 */
export const sendTestMessage = async (message: string): Promise<void> => {
  await api.post('/line/send_message', { message });
};
